module.exports = __webpack_public_path__ + "img/caseBuilder-marketing.eae1c16d.webp";